import { Card, CardContent } from '@/components/ui/card';
import { DatabaseEmployee } from '@/types/employee';

interface DashboardHeaderProps {
  profile: DatabaseEmployee | null;
  isFirstUser: boolean;
}

export const DashboardHeader = ({ profile, isFirstUser }: DashboardHeaderProps) => {
  return (
    <Card>
      <CardContent className="p-6">
        <h2 className="text-2xl font-bold mb-4">
          {isFirstUser 
            ? "Welcome to Unstuck Labs!" 
            : `Welcome back, ${profile?.first_name || 'there'}!`}
        </h2>
        {isFirstUser && (
          <p className="mb-4">
            To get started, please create your employee profile. 
            As the first user, you'll be set up as an administrator.
          </p>
        )}
      </CardContent>
    </Card>
  );
};